import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import React, { Component } from 'react';
import { format } from 'date-fns';
export default class Chart_vd_temp extends Component {
    constructor(props) {
        super(props);
        //this.chartRef = React.createRef();
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.data !== this.props.data) {
            this.componentDidMount();
        }
    }
    componentDidMount() {
        //const myChartRef = this.chartRef.current.getContext("2d");
        var ctx = document.getElementById('Chart_vd_temp').getContext('2d');
        const data = this.props.data;
        const date = this.props.date;
        var x_data = [];
        var y_data = [];
        for (var i = 0; i < data.length; i++) {
            x_data.push(data[i]['mean_1']);
            var tmp = format(new Date(data[i]['time']), "yyyy/MM/dd");
            y_data.push(tmp);
        }
        console.log(x_data);
        console.log(y_data);
        var isstepped = false;
        if (window.Chart_vd_temp instanceof Chart) window.Chart_vd_temp.destroy();
        window.Chart_vd_temp = new Chart(ctx, {
            type: "line",
            // plugins: [ChartDataLabels],
            data: {
                //Bring in data
                labels: y_data,
                datasets: [
                    {
                        label: 'Temperature (°C)',
                        data: x_data,
                        steppedLine: isstepped,
                        backgroundColor: '#c54b8c',
                        borderColor: '#c54b8c',
                        pointBackgroundColor: '#893462',
                        pointBorderColor: '#893462',
                        fill: false,
                        tension: '0.5',
                        datalabels: {
                            // anchor: 'end',
                            // align: 'top',
                            // formatter: function (value) {
                            //     return Math.round(value * 10) / 10 + '°C';
                            // },
                            // // formatter: Math.round,
                            // font: {
                            //     weight: 'bold'
                            // }
                            display: false
                        }
                    }
                ]
            },
            options: {
                //Customize chart options
                responsive: true,
                legend: {
                    display: false
                },
                scales: {
                    xAxes: [{
                        type: 'time',
                        offset: true,
                        time: {
                            unit: 'day'
                        }
                    }],
                },
                title: {
                    display: true,
                    text: "Temperature",
                    fontSize: 30,
                    fontFamily: 'Noto Sans CJK TC'
                }
            }
        });
    }
    render() {
        return (
            <div>
                <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.9.4/Chart.js"></script>
                <canvas id="Chart_vd_temp"></canvas>
            </div>
        );
    }
}